import React, { useContext } from "react"
import tw from "twin.macro"
import { useStaticQuery, graphql } from "gatsby"

import { handleNavClick } from "../utils"

// component imports
import Hero from "../components/hero"
import InternalCta from "../components/internal-cta"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Callout from "../components/callout"
import { myContext } from "../context/Provider"

import PatientContent from "../components/patient-content"
import CallingAllAdvocates from "../components/calling-all-advocates"
import auveleityAndMe from "../images/logo/auvelity-and-me-logo.svg"

const PatientStories = () => {
  const { bgdesktop, bgmobile, site } = useStaticQuery(graphql`
    query {
      bgdesktop: file(
        relativePath: { eq: "hero/patient-stories-desktop.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 1440, quality: 100, placeholder: BLURRED)
        }
      }
      bgmobile: file(
        relativePath: { eq: "hero/patient-stories-mobile.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 960, quality: 100, placeholder: BLURRED)
        }
      }
      site {
        siteMetadata {
          globalSchema
        }
      }
    }
  `)

  const context = useContext(myContext)

  const heroData = {
    classInfo: "patient-hero-data main-patient",
    icon: null,
    title: null,
    logo: auveleityAndMe,
    logoAlt: "Auvelity and Me logo",
    hidePatientStories: true,
    subtitle: (
      <>
        Meet the real faces<br />of&nbsp;AUVELITY 
      </>
    ),
    fingerTabs: true,
    paragraph1: (
      <>
        <p tw="pb-2 mt-[0px] lg:(mt-6)">
          Hear how Mecca, Ryan, Cindy, and Danielle—real people living with depression—are getting back to feeling more like themselves again with AUVELITY.
        </p>
        <Callout color="yellow" extraClasses="watch-their-stories-cta">
          <div onClick={e => handleNavClick(e, "#real-patients")}>
            <p tw="font-semibold text-blue text-base">
              Watch their stories
            </p>
          </div>
        </Callout>
      </>
    ),
  }

  return (
    <Layout>
      <Seo
        title="Patient Stories - AUVELITY (dextromethorphan-bupropion)"
        description="Hear from real patients about their experience with AUVELITY. Please see Medication Guide, including Boxed Warning."
        socialTitle="Patient Stories - AUVELITY (dextromethorphan-bupropion)"
        socialDescription="Hear from real patients about their experience with AUVELITY. Please see Medication Guide, including Boxed Warning."
        schema={site.siteMetadata.globalSchema}
      />
      <Hero dataObj={heroData} env="white" bgImgData={!context.isMobile ? bgdesktop : bgmobile} className="patient-stories-hero" variant="patient" main />
      <PatientContent />
      
      <div>
        <CallingAllAdvocates />
      </div>

      <div className="patient-ctas">
        <InternalCta
          ctaData={[
            {
              title: <span>Well, that’s different</span>,
              text: <span>Learn about how AUVELITY&nbsp;works</span>,
              path: "/how-auvelity-works",
            },
            {
              title: <span>Tips to start the convo</span>,
              text: (
                <span className="text-center">
                  Download the conversation starter guide for tips when talking to your doctor
                </span>
              ),
              textStretch: true,
              path: "/resources#patient-brochure",
            },
          ]}
          variant="patient"
        />
      </div>
    </Layout>
  )
}
export default PatientStories
